/* global axios */
import ApiClient from './ApiClient';

class RealEstateBrokerDashboardAPI extends ApiClient {
  constructor() {
    super('real_estate_broker_dashboard', { accountScoped: true });
  }

  index(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new RealEstateBrokerDashboardAPI();
